import React, { useState, useEffect} from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  TextField,
  Button,
  IconButton
} from "@material-ui/core";
import {
  CircularProgress,
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import {
  Add,
  Close,
  Delete,
  Gavel,
  GroupWork
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { makeStyles } from "@material-ui/styles";
import {Wizanlytics} from "./../../../../../utils/web_config_2";
import { useSnackbar } from "notistack";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      [theme.breakpoints.up("sm")]: {
        marginLeft: 250,
      },
    },
    title: {
      flexGrow: 1,
    }
  }));


function UserAward(props){
    const classes = useStyles();

    const [token,setToken]=useState("eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5M2FmZTc3OC1mZWExLTRjMDktYTNlMy1kNmM3MzkyNjRmODciLCJqdGkiOiI0NzBiYWEwZjczOWQyNGVlZThhMTIzMDhkNDJjYWI5YjNkMjUwMDU4NDRhZWU5YzNjZjYxYmNmMzE4MTgzZmYxZmIxMjdhMDRkMjIyZDQxNCIsImlhdCI6MTYyNDgyMDUyNS43Mzg3NDgsIm5iZiI6MTYyNDgyMDUyNS43Mzg3NiwiZXhwIjoxNjU2MzU2NTI1LjczMDE0Mywic3ViIjoiIiwic2NvcGVzIjpbXX0.4GSyTd6LzKB-JFP8oQ_DsITZXAmnVBfqMlwvoiJkiXLI9p3hD1HlpC36bcGA0qnxkOblnC2sqLjEcdNrybY6dqRrHTOGRr_6plFuhaL1pUm4E8xj-A0uwCpoPPdxaiZBwAT-SNPX3VzCYRo147VYaX2g9O8FcCp9lnqd4f71V6RnYA_h1PEOGk16UxT1Bvx25MDKZl6G722PR0R65v4dV8wDPHiW8vtFYsIGvE25LPyhG6UUikGlsYd9Eg8zE4AbSQ9BNYKkXiFQ6zNbZJM31I3PAX6kK9nlY13SehnL8CAlbCPRZtq8fu3O9uUaxfP0pOgmROjDDu7sxpWKbrWjOv97ISXFle-gUcmc17c-49zW9pmrWeAnpO14xNQ34OWRxID-opx-XNNU5lEinqTN-y9fP06mUvY0X-YkIR8p2kYJubwl2jaS2ttTVI67mxr4tafqh5gZhiWY6aB2_8oAOMZQG5bNwTqexurqUqiFZLCbnootgqLQKavHmdyt8nSP4F-VkNNUSo3Fu18GqwG3oDhFVYcUPW6Ke6_EgsJcFRQC1B-UvC4LkY6imxqvlfTWP4Hy4tjRRaPBwYqzO78aXokZ_Wm7mmFsFGV3J7dWdUVXLkOAyc7iznBvHVMd3iRVAeMfPAbMPpWug6wB-_mE1CwXgmxxDqc5q0bNxeHYAfs");

    useEffect(() => {

        getUserBalance();

      }, []);

      const [status,setStatus]=useState("Loading user awards");




//   user column 


    const columns = [
        {
            name: "id",
            label: "id",
            options: {
              filter: false,
              sort: false,
              display:"excluded"
            },
          },
    
        {
          name: "type",
          label: "Type",
          options: {
            filter: false,
            sort: true,
          },
        },

        {
          name: "phone_number",
          label: "Phone Number",
          options: {
            filter: false,
            sort: false,
          },
        },  {
          name: "balance",
          label: "Balance",
          options: {
            filter: false,
            sort: false,
          },
        }
      ];


      const options = {
        filterType: false,
        elevation: 0,
        selectableRows: false,
        searchPlaceholder: "Search client...",
        selectableRowsOnClick: false,
        fixedHeader: true,
        searchProps: {
          variant: "outlined",
          margin: "dense",
        },
        textLabels: {
          body: {
            noMatch: status,
          },
        }
      };

      //select users balance 

    
      const [balance,setBalance]=useState({
          data:[],
          loading:false
      })
      const getUserBalance=()=>{
        setBalance({...balance,loading:true});
        const rulesInstance = axios.create(new Wizanlytics().setHeaders(token));
        rulesInstance
          .get(new Wizanlytics().GET_USER_BALANCE)
          .then((res)=>{
            setBalance({...balance,loading:false});
              var data=res.data.data;
              if(data.length==0){
                setStatus("No User awards available");
              }else{
                var balances=[];
                data.forEach((b, i) => {
                  const newBal = b;
                  newBal['phone_number']=b.attributes.phone_number;
                  newBal['balance']=b.attributes.balance;
      
                  balances.push(b);
                });
  
                setBalance({...balance,data:balances});
              }
              

          })
          .catch((err)=>{
            setStatus("Something went wrong");
            setBalance({...balance,loading:false});
          });
    
      }

    return(
        <div className={classes.root}> 
        <Box display="flex">
        <Box mr={2}>
          {" "}
          <GroupWork color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>User Rewards</b>
        </Typography>
      </Box>

      <Box mt={3} />

        {balance.loading&& <LinearProgress />}
        <MUIDataTable
        title={"Client rewards"}
        data={balance.data}
        columns={columns}
        options={options}
        />

        </div>
    );

}

export default withLocalize(UserAward);